import React, { Component } from 'react';
// import logo from './logo.svg';

import {
    withRouter,
    Route,
    Switch
} from 'react-router-dom';

import {
    TransitionGroup, CSSTransition
} from 'react-transition-group';

import './App.css';

import About        from './components/about';
import ContactPage  from './components/leadForm';
import CV           from './components/cv';
import Navigation   from './components/nav';

import {
    Gear,
    UserXHeading
} from './components/presentation';

class App extends Component {



  render() {

      const {location} = this.props;



    return (
      <div className="app">
          <div className="app-wrapper">

              <header className="app-header">
                  <UserXHeading />
              </header>

              <Gear className="gear-wrap ul" />
              <Gear className="gear-wrap ur" />
              <Gear className="gear-wrap lr" />
              <Gear className="gear-wrap ll" />

              <div className="app-wrapper-content">
                  <div className="app-vertical-spacer">
                  </div>
                  <main className="app-main">

                      <TransitionGroup>
                          <CSSTransition
                              key={location.key}
                              // timeout={300}
                              timeout={1300}
                              classNames='slide'
                          >
                              <Switch location={location}>
                                  <Route
                                      exact
                                      path='/cv'
                                      component={CV}
                                  />
                                  <Route
                                      exact
                                      path='/contact'
                                      component={ContactPage}
                                  />
                                  <Route
                                      exact
                                      path='/'
                                      component={About}
                                  />
                              </Switch>

                          </CSSTransition>

                      </TransitionGroup>


                  </main>
                  <footer className="app-footer">
                      <Navigation />
                  </footer>
              </div>
          </div>
      </div>
    );
  }
}

App = withRouter(App);

export default App;



// WEBPACK FOOTER //
// ./src/App.js